import { render } from "./BaseComplexToggle.vue?vue&type=template&id=2a1ba89f&scoped=true&ts=true"
import script from "./BaseComplexToggle.vue?vue&type=script&lang=ts"
export * from "./BaseComplexToggle.vue?vue&type=script&lang=ts"

import "./BaseComplexToggle.vue?vue&type=style&index=0&id=2a1ba89f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.27_typescript@5.3.3__webpack@5.91.0_webpack-cli@5.1.4_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1ba89f"]])

export default __exports__